<template>
  <v-dialog
    v-if="request"
    :value="value"
    width="640"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        <span class="headline">申請の却下</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <AppForm label="ベースメニュー" single-span>
            <MenuType :value="request.menuType" />
          </AppForm>
          <AppForm label="配信単価" class="pt-3" single-span>
            <AppCurrency
              :value="request.unitPrice"
              :currency="request.currency"
            />
          </AppForm>
          <AppForm label="使用可能範囲" class="pt-3" single-span>
            <ResourceType :value="request.resourceType" />
            {{ request.resourceName }}
          </AppForm>
          <AppForm label="使用可能期間" class="pt-3" single-span>
            <AppPeriod
              :start="request.startDate"
              :end="request.endDate"
              is-date
            />
          </AppForm>
          <v-textarea
            v-model="reason"
            outline
            label="却下理由（必須）"
            class="pt-4"
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="!isValid" color="primary" @click="execReject"
          >却下</v-btn
        >
        <v-btn color="primary" @click="$emit('input', false)">キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ResourceType from '@/components/Shared/Presentation/ResourceType'
import MenuType from '@/components/Shared/Presentation/Menu/MenuType'

export default {
  name: 'RejectModal',
  components: { ResourceType, MenuType },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      reason: '',
    }
  },
  computed: {
    isValid() {
      return this.reason.length > 0
    },
  },
  methods: {
    execReject() {
      this.$emit('reject', { request: this.request, reason: this.reason })
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;
}
</style>
